import Tests from './Tests';
export default Tests;